module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter"
  }, [_vm._v("Chapter One")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At least she was still alive. If only just.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stared down at the supine motionless form, cocooned in bandages, sustained by tubes and wires. I couldn’t see her breathing, but the flickering line on the display panel of one of the battery of machines at her bedside appeared to be monitoring her respiration.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was getting the best medical attention that money could buy. Her employer could do no less. He’d better not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took a step closer, but did not need the warning gesture from the young doctor to restrain me. I wasn’t going to touch her. I was afraid to. She looked so fragile—a shattered doll that had been jigsawed back into a semblance of its former shape, but which might disintegrate beyond restoration if breathed on too heavily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Hi there, Nessa.’ I settled for vocal contact instead, in the voice we so nearly shared. ‘Your other half is here. It’s going to be all right now.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The doctor glanced at me quickly and then glanced away again. He didn’t contradict me, but his expression was not optimistic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re going to be all right now.’ I spoke with more firmness than I felt. My knees were turning to jelly, something twisted in the pit of my stomach. She was so pale … so still.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What happened?’ I asked. The garbled message that had reached me had told me little. Only that she needed "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v(" me. I had abandoned my plans for a leisurely sea voyage back to England and caught the first jet instead.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She fell from a considerable height, I understand. I’m told she was in the habit of wandering along the battlements when she couldn’t sleep at night. She must have missed her footing.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Whoever told you that was … mistaken. She was afraid of heights. She’d never have done that.’ It was one of the few points where we diverged. Heights didn’t bother me. But she had been afraid with good reason, it seemed now. Had that fear been a presentiment of what lay in her future?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well …’ His face shadowed, he pointed out the irrefutable. ‘It happened. She’s lucky the patrol dogs found her in the dry moat beneath the battlements. Otherwise, she might have lain there all night. That would have …’ He let the thought trail off. I could finish the sentence for myself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘At least she has a fighting chance now.’ I wasn’t going to give up and I knew that she wouldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We’ll do our best.’ Against my will, I identified the expression that flitted across his face: it was pity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She’ll be all right,’ I said. ‘She’s a fighter.’ And so am I. I wanted to know how this could have happened to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Er …’ He cast a worried glance at the information registering on the various screens. ‘It might be better if we left her to rest now.’ He led the way outside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She’s going to be all right,’ I insisted. ‘There are two of us fighting now.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You know …’ He assessed me carefully. ‘You’re not what I expected.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I know,’ I said. ‘I’m never what anyone expected. But enough of me. Nessa is the important one here. What else is being done for her? Are there any specialists we can call in? Does she need a blood transfusion? We match, of course.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("‘Everything possible is being done. Mr Oversall has seen to that. It’s a question of time now.’ ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And does Mr Oversall know that? I rang his office for information as soon as I got to London. They didn’t give me the impression that Nessa’s condition was serious at all. They made it sound as though they expected her back at work in a couple of days.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ah, yes.’ He looked embarrassed. ‘Our Mr Oversall is notoriously optimistic. He’s had to be—or he wouldn’t be where he is today.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the richest men in the world. Notorious, indeed, for investing in schemes wiser men shunned, like backing dubious freedom fighters in areas of upheaval, or buying up mineworkings popularly supposed to be exhausted which subsequently turned out to have hidden resources unsuspected by the owners who had sold them to him. A lucky man—or one with impeccable sources of information.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘People tend to tell Mr Oversall what he wants to hear.’ He was apologetic. ‘I’m the junior doctor in this practice. I couldn’t contradict what the senior partner said.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The man who pays the piper is the man who calls the tune. ")]), _vm._v("And Mr Oversall paid well. But what would he say if the tune became discordant, the music jangled … the patient died?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wasn’t going to let myself think that but, just for a moment, I faltered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I won’t deny I’m not entirely happy,’ he went on. ‘I … I’ve met Nessa … several times. I … I liked her. I’d formed the opinion that she was a calm and sensible person—unlike most of Mr Oversall’s …’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Harem.’ I supplied the word he had baulked at. It had been used often enough in the tabloids. The more discreet broadsheets usually opted for ‘Amazon Army’ to describe the plethora of nubile females surrounding the billionaire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I wasn’t suggesting your sister—’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("‘I should hope not! Nessa was—is—a proper employee. Mr Oversall’s Personal Assistant. She has no connection with the … the ladies … who make up his entourage.’ ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Exactly!’ He nodded vehemently. ‘Nessa is different … special …’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Exactly!’ I nodded in turn, beginning to wonder about his relationship with my twin. Interested? Smitten? Or …? ‘I think I’d like to have a few words with your senior partner,’ I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Unfortunately, that’s not possible.’ He was on the defensive again. ‘I mean, Dr Ranjit is out on a call. I don’t know when he’ll be back.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I can wait.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I doubt it. He’s on his way to Saudi Arabia. There’s been some sort of outbreak at one of the installations. They’re hoping to avoid an epidemic.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I take it the installation belongs to Mr Oversall.’ It wasn’t a question.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Right. Our … our practice … is largely … er … involved … with Oversall Enterprises. We have very few National Health or private patients.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why was I not surprised? It all made perfect sense. Of course, Mr Oversall would maintain his own medical unit for his far-flung empire. So much easier than having to deal with all the local regulations, restrictions and native doctors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And I suppose the police have not been informed about Nessa’s … accident?’ It was another question to which I already knew the answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Police?’ He recoiled. ‘What have they to do with it? They aren’t automatically called to the scene of every accident. Our own paramedics got there faster than any other ambulance could have. I assure you, she’s having the best of care.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("‘Of course.’ Just as I had suspected. No names, no pack drill … no record. Whatever had happened was going to be swept under the carpet—a very expensive, highest-quality Oriental carpet, but a carpet nonetheless. Whatever had happened to her, for whatever reason, was going to be swept away. Lost, as she might be … ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I want to know what happened,’ I said. ‘From the very beginning.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I wouldn’t mind knowing myself,’ he admitted. ‘If she recovers enough to tell us …’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No.’ I stood there, all my energy concentrated on sending out a mental call to Nessa to respond. It had often worked in the past, no matter how far apart we had been. Not this time. She was too far away, whatever spark she had was curled up in the centre of her being, fighting to survive, to return to life. She needed all her own energy for that. I cut off the signal, it wasn’t fair to ask her to dissipate any energy that was left to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No.’ I stood there, limp and empty but for a growing rage. ‘I can’t wait that long.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And even if … when … she recovers consciousness—’ he was having trouble treading the line between honesty and optimism; just as well Mr Oversall wasn’t here—‘we don’t know how much brain damage there might be. There’s usually short-term memory loss in cases like this, especially about events just before the accident. She may never be able to tell you anything about it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Amnesia …’ I said. ‘Temporary amnesia.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It might be permanent,’ he warned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Somewhere in the back of my mind, I had known that: read it, heard it, learned it in some long-ago psychology course. A plan began to form in my mind. Or had it been there all along?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Have you mentioned this to anyone at Friary Keep?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not really.’ He looked uncomfortable. ‘No one’s asked. Apart from Mr Oversall, of course, and my senior partner handled that … before he went away.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Poor Nessa …’ There had been vague intimations in some of her letters. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bitch!")]), _vm._v(" The echo of that hateful whisper surfaced faintly in my mind. ‘Not very popular, was she?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No one was.’ His mouth twisted wryly. ‘It’s everyone for themselves in that set-up. Nothing to take personally.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("‘A strange ménage.’ He couldn’t deny it. ‘So no one ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v(" knows, or particularly cares about, the actual position. Except for the optimistic Mr Oversall, who is expecting Nessa back on duty in very short order.’")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m afraid that sums it up.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And now your senior has gone away and you’re the one left to tell Mr Oversall the unpalatable truth.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes.’ He knew it. He’d known it all along, but he didn’t like having it pointed out to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mr Oversall isn’t going to like it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, but they don’t kill the messenger any more.’ His uncertain smile said he wished he could be sure of that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I wouldn’t bet on it.’ Shamelessly, I preyed on his fears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I understand Mr Oversall can be quite nasty when thwarted.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘One hears rumours.’ He lost a little more colour. ‘But even a billionaire has to face reality occasionally.’ Mortality, he meant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not necessarily. I think we should send Nessa back to him. A little the worse for wear, perhaps, and not quite up to the job for a while longer. In need of rest—but able to learn quite a lot while she takes her time recovering.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What do you mean? She can’t possibly be moved. You’ve seen—’ He broke off, looking at me with growing—and justified—suspicion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ll take her place. We’re twins, remember.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But—but—you can’t!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘With your help, I can. Just make sure everyone knows that I’m suffering from amnesia. I think we’ll make that total amnesia, not just the short-term kind.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smiled. The gowns, the wigs, the glitter, the glamour that comprised my stage persona, Gloriana, were all packed away in the theatrical trunks following me in the hold of the liner I had intended to sail in, but who needed them? I half-turned, moistened my lips and gave him a smouldering look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You—you’re—’ He choked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("‘Go ahead, say it.’ I shrugged languorously. ‘I’ve been ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v(" called obscene before.’ It was his own reaction that had shocked him, I knew. That split second in which he had felt the pull, glimpsed the dark side of the moon.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I didn’t mean that,’ he said. ‘I mean, you’ll never get away with it!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, yes, I will!’ I dropped the coquetry and let my face reveal the depth of my fury—and my determination. Someone had tried to kill Nessa and I intended to find out who. ‘All you have to do is sell them the amnesia story. You can do that, can’t you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, but—you—He shook his head. ‘You’re—’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("‘I’ll tell you what I am,’ I snapped. ‘Twindom apart, I’m the best damned female impersonator in the business!’ ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-481ed943","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Chapter_1.vue
// module id = 75
// module chunks = 0